import { SIDEBAR_WIDTH } from '~/components/ui/sidebar';
import { Skeleton } from '~/components/ui/skeleton';
import { cn } from '~/lib/utils';

interface AuthLoaderProps {
  mode?: 'full' | 'content';
}

export function AuthLoader({ mode = 'full' }: Readonly<AuthLoaderProps>) {
  return (
    <div
      className="flex h-screen"
      style={
        {
          '--sidebar-width': SIDEBAR_WIDTH,
        } as React.CSSProperties
      }
    >
      {/* Sidebar skeleton */}
      {mode === 'full' && (
        <div
          data-testid="sidebar-skeleton"
          className="border-r p-4 flex flex-col gap-4"
          style={{ width: 'var(--sidebar-width)' }}
        >
          {/* User profile skeleton */}
          <div data-testid="user-profile-skeleton" className="flex items-center gap-3 p-2">
            <Skeleton className="h-10 w-10 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-3 w-16" />
            </div>
          </div>

          {/* Navigation items skeleton */}
          <div className="space-y-2">
            {[...Array(6)].map((_, i) => (
              <div key={i} data-testid="nav-item-skeleton" className="flex items-center gap-3 p-2">
                <Skeleton className="size-4" />
                <Skeleton className="h-4 w-24" />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Main content skeleton */}
      <div data-testid="main-content-skeleton" className={cn('flex-1', mode !== 'content' && 'p-6')}>
        <div className="flex flex-col gap-4">
          {/* Header skeleton */}
          <div className="flex justify-between items-center">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-8 w-32" />
          </div>

          {/* Content skeleton */}
          <div className="grid grid-cols-3 gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} data-testid="content-card-skeleton" className="p-4 border rounded-lg space-y-3">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
                <Skeleton className="h-4 w-2/3" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
